import React, { useEffect } from "react";
import { Button, Form, Input, Select, Space, Card } from "antd";
import { Spinner } from "../../../lib";
import dayjs from "dayjs";
import { CalendarOutlined } from "@ant-design/icons";

const Filters = ({
  setDepChange,
  setRoleChange,
  departments,
  users,
  roleOption,
  projects,
  submitData,
  setPayloadData,
  payloadData,
  isAdmin,
  isLoading,
}) => {
  const [form] = Form.useForm();

  const updateDateRange = (from, to) => {
    const formatted = {
      fromDate: dayjs(from).format("YYYY-MM-DD"),
      toDate: dayjs(to).format("YYYY-MM-DD"),
    };

    setPayloadData((prev) => ({ ...prev, ...formatted }));
    form.setFieldsValue(formatted);
  };

  const handleDateRange = () => {
    const today = new Date();
    const from = new Date(today.getFullYear(), today.getMonth(), 1); // 1st of current month
    const to = today;

    updateDateRange(from, to);
  };

  const handlePreviousMonth = () => {
    const from = dayjs().subtract(1, "month").startOf("month").toDate();
    const to = dayjs().subtract(1, "month").endOf("month").toDate();
    updateDateRange(from, to);
  };

  const handleMonthSelection = (value) => {
    if (value === "current") handleDateRange();
    else if (value === "previous") handlePreviousMonth();
  };

  useEffect(() => {
    form.setFieldsValue({
      fromDate: payloadData.fromDate,
      toDate: payloadData.toDate,
    });
  }, [payloadData]);

  return (
    <Card
      bordered={false}
      style={{
        borderRadius: 8,
        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
        marginBottom: 16,
      }}
    >
      <Form
        form={form}
        onFinish={submitData}
        layout="inline"
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "1rem",
          alignItems: "flex-start",
        }}
      >
        <Form.Item label="Department" name="dep" style={{ minWidth: 200 }}>
          <Select
            placeholder="Select Department"
            onChange={setDepChange}
            showSearch
            filterOption={(input, option) =>
              option.children.toLowerCase().includes(input.toLowerCase())
            }
          >
            {departments.map((dep) => (
              <Select.Option key={dep._id} value={dep._id}>
                {dep.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item label="Role" name="roleData" style={{ minWidth: 200 }}>
          <Select placeholder="Select Role" onChange={setRoleChange}>
            {roleOption.map((role) => (
              <Select.Option key={role.value} value={role.value}>
                {role.label}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        {isAdmin && (
          <Form.Item label="User" name="user" style={{ minWidth: 220 }}>
            <Select
              placeholder="Select User"
              showSearch
              filterOption={(input, option) =>
                option.children.toLowerCase().includes(input.toLowerCase())
              }
            >
              {users.map((user) => (
                <Select.Option key={user._id} value={user.email}>
                  {user.email}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        )}

        {isAdmin && (
          <>
            <Form.Item
              label="Month"
              name="monthSelection"
              style={{ minWidth: 200 }}
            >
              <Select
                placeholder="Select Month"
                onChange={handleMonthSelection}
                suffixIcon={<CalendarOutlined />}
              >
                <Select.Option value="current">Current Month</Select.Option>
                <Select.Option value="previous">Previous Month</Select.Option>
                <Select.Option value="custom">Custom Range</Select.Option>
              </Select>
            </Form.Item>

            <Form.Item label="From" name="fromDate" style={{ minWidth: 180 }}>
              <Input
                type="date"
                onChange={(e) =>
                  setPayloadData({ ...payloadData, fromDate: e.target.value })
                }
              />
            </Form.Item>

            <Form.Item label="To" name="toDate" style={{ minWidth: 180 }}>
              <Input
                type="date"
                onChange={(e) =>
                  setPayloadData({ ...payloadData, toDate: e.target.value })
                }
              />
            </Form.Item>
          </>
        )}

        {/* Buttons for non-admin */}
        {!isAdmin && (
          <Space>
            <Button onClick={handlePreviousMonth}>Previous Month</Button>
            <Button onClick={handleDateRange}>Current Month</Button>
          </Space>
        )}

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            style={{ borderRadius: 4, minWidth: 120 }}
          >
            {isLoading ? <Spinner /> : "View Report"}
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default Filters;
